// extracted by mini-css-extract-plugin
export default {"upper_button":"Component_upper_button__3PIWR"};